<template>
	<dms-wrapper :label="labelText" v-bind="{span, wrapp, validationRules, noLabelAlign}" :show-label="false"
		:validation-property="validationPropertyCmp" :disabled="isDisabled">
		<span v-if="!isCheckBoxButton" :class="addPadding ? 'checkbox-label pd-10':'checkbox-label'">{{ computedLabel }}</span>
		<el-checkbox v-if="!isCheckBoxButton" v-bind="{value, indeterminate}" :disabled="isDisabled" :data-cy="labelKey"
			:class="{'frm-group-checkbox': !oneLine}" @change="$emit('update:value', $event)">
			<slot />
		</el-checkbox>
		<el-checkbox-button v-if="isCheckBoxButton" :class="{'frm-group-checkbox': !oneLine}"
			v-bind="{value}" :data-cy="labelKey" @change="$emit('update:value', $event)">{{ computedLabel }}</el-checkbox-button>
	</dms-wrapper>
</template>

<script>
import { BaseInput } from '#components/dms/common/baseInput';
import DmsWrapper from '#components/dms/form/Wrapper.vue';

export default BaseInput.extend({
	name: 'DmsCheck',
	components: { DmsWrapper },
	props: {
		indeterminate: { type: Boolean, default: false },
		oneLine: { type: Boolean, default: false },
		showText: { type: Boolean, default: true },
		span: { type: Number, default: 24 },
		noLabelAlign: { type: Boolean, default: false },
		isCheckBoxButton: { type: Boolean, default: false },
		addPadding: { type: Boolean, default: false },
	},
	computed: {
		computedLabel() {
			return this.showText ? (this.placeholderText || this.labelText) : '';
		},
	},
});
</script>
